import { ApiServiceHtmlResponse, CustomFormReport } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  isInternalPdf: boolean;
  publicLinkIdForFilesSummarySection?: number;
  customFormReportIdForFilesSummarySection?: number;
  customFormReport: CustomFormReport;
}

interface ResponseDataType extends ApiServiceHtmlResponse {
}

export const generateCustomFormReportPdfPreviewWithImagesRequest = ({
                                                                      token,
                                                                      isInternalPdf,
                                                                      publicLinkIdForFilesSummarySection,
                                                                      customFormReportIdForFilesSummarySection,
                                                                      customFormReport,
                                                                    }: RequestParams, abortSignal: AbortSignal): Promise<ResponseDataType> => {
  const searchParameters = new URLSearchParams();
  searchParameters.set('is_internal_pdf', isInternalPdf.toString());
  if (publicLinkIdForFilesSummarySection) {
    searchParameters.set('public_link_id_for_files_summary_section', publicLinkIdForFilesSummarySection?.toString() ?? '');
  }
  if (customFormReportIdForFilesSummarySection) {
    searchParameters.set('custom_form_report_id_for_files_summary_section', customFormReportIdForFilesSummarySection?.toString() ?? '');
  }
  searchParameters.set('custom_form_report', JSON.stringify(customFormReport));

  return ApiServiceInstance.makeRequest(`/custom-form-report/pdf/preview/generate-with-images?${ searchParameters.toString() }`, {
    abortSignal,
    method: 'GET',
    token,
  });
};